import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { pick, isEmpty, omitBy } from 'lodash';
import MatrixRow from '../../layout/MatrixRow';
import MatrixCell from '../../layout/MatrixCell';
import MatrixRowForm from '../MatrixRowForm';
import generateMatrixRowFormName from '../../../../../../utils/generateMatrixRowFormName';
import styles from './MatrixTableField.scss';
import MatrixAlignedCell from '../MatrixAlignedCell';
import propTypeBlockStyling from '../../../../../../domains/styling/config/editorBlock/PropTypes/blockStyling';

class MatrixTableField extends Component {
  static propTypes = {
    inputRowField: PropTypes.func.isRequired,
    input: PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.object,
      onChange: PropTypes.func.isRequired,
    }).isRequired,
    block: PropTypes.shape({
      itemList: PropTypes.array,
      labelAlignments: PropTypes.shape({
        horizontal: PropTypes.string.isRequired,
        vertical: PropTypes.string.isRequired,
      }),
    }).isRequired,
    styling: propTypeBlockStyling,
  };

  handleAnswer = formValues => {
    this.props.input.onChange(
      omitBy({ ...this.props.input.value, ...formValues }, isEmpty),
    );
  };

  render() {
    const {
      input: { value },
      block,
      block: {
        clientUuid,
        required,
        options,
        itemList,
        shape,
        labelAlignments,
      },
      inputRowField,
      styling,
    } = this.props;

    return (
      <div className={styles.container}>
        <table cellSpacing={0} cellPadding={0} className={styles.table}>
          <thead className={styles.header}>
            <MatrixRow>
              <MatrixCell />
              {itemList.map(label => (
                <MatrixAlignedCell
                  key={label.id}
                  value={label.value}
                  labelAlignments={labelAlignments}
                  styling={styling}
                />
              ))}
            </MatrixRow>
          </thead>
          <tbody className={styles.body}>
            {options.map(option => (
              <MatrixRowForm
                key={option.id}
                enableReinitialize
                form={generateMatrixRowFormName(clientUuid, option.id)}
                asyncChangeFields={[option.id]}
                asyncBlurFields={[option.id]}
                initialValues={pick(value, [option.id])}
                labelList={itemList}
                inputRowField={inputRowField}
                required={required}
                onSubmit={this.handleAnswer}
                option={option}
                block={block} // passing `block` to respect getRenderedScaleIcons signature @sinslav
                shape={shape}
                styling={styling}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default MatrixTableField;
